import React, { memo } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { DisclaimerText, Section } from 'reaxl';
import homeServicesConfig from '../homeServicesConfig';
import HomeServicesItemCard from '../HomeServicesItemCard';

/**
 *  Dealer home services content and button CTA
 *
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const HomeServices = /*#__PURE__*/memo(_ref => {
  let {
    className,
    imageWidth,
    headingClassName,
    contentClassName,
    heading,
    services,
    showHeader = true,
    customServiceContent,
    ...rest
  } = _ref;
  const {
    content: {
      heading: dhsHeading,
      disclaimer,
      disclaimerMoneyBack
    }
  } = homeServicesConfig;
  const hasMoneyBack = Array.isArray(services) ? services.includes('moneyBackGuarantee') : 'moneyBackGuarantee' in services;
  return /*#__PURE__*/_jsxs(Section, {
    "data-cmp": "homeServices",
    className: clsx('display-grid', className),
    uiContext: "level-3",
    alignment: "left",
    heading: showHeader && (heading || dhsHeading),
    headingClassName: headingClassName,
    ...rest,
    children: [/*#__PURE__*/_jsx(HomeServicesItemCard, {
      className: contentClassName,
      imageWidth: imageWidth,
      services: services,
      customServiceContent: customServiceContent
    }), /*#__PURE__*/_jsx(DisclaimerText, {
      className: "margin-top-3",
      children: disclaimer
    }), hasMoneyBack ? /*#__PURE__*/_jsx(DisclaimerText, {
      className: "margin-top-1",
      children: disclaimerMoneyBack
    }) : null]
  });
});
export default HomeServices;